export class NgCamInitError {
  public message: string = null;
  public mediaStreamError: MediaStreamError = null;
}
